import React, { useEffect } from "react";
import { useState } from "react";
import {
    onCloseModal,
    onConfirmModal,
    onOpenModal,
} from "../utils/dialog.individual_task";
import { useSetStep } from "../stores/useStepNumber";
import { useForm } from "react-hook-form";
import useStoreTasksLocally, {
    useSetAddTasksLocally,
    useSetTasksLocally,
    useTasksLocally,
} from "./useStoreTasksLocally";
import { _format_tasks_definition_table } from "../utils/func.tasks";
import { ROUTES } from "../../../constants/routes";
import { useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import { _api_post_tasks_start_offboarding } from "../api";
import { useUserOffboarding } from "./useUserOffboarding";
import { useToastGlobal } from "../../../stores/useToastGlobal";

const useLogicTaskIndividual = () => {
    // * HOOKS
    // * HOOKS
    // * HOOKS
    useSetStep(5); // on est a la 5eme étape
    const navigate = useNavigate();
    const toast = useToastGlobal();
    // * CONTEXTS
    const CtxTasksLocally = useTasksLocally();
    const CtxSetAddTasksLocally = useSetAddTasksLocally();
    const { user_offboarding, setUserOffboarding } = useUserOffboarding();

    // * STATES
    const [stateDialog, setStateDialog] = useState(false);

    // * FORM
    // add task
    const methods = useForm({
        mode: "onChange",
        defaultValues: {
            document_required: null,
            document_action: 5, // aucun document requis
            saved_files: [], // document uploaded from Dialog add task
            type: 1, // type is the value of the slidertabs on dialog add task
        },
    });

    // * QUERIES & MUTATIONS
    // * QUERIES & MUTATIONS
    // * QUERIES & MUTATIONS
    const {
        data,
        mutate,
        isLoading: is_loading_send_tasks,
    } = useMutation(
        (data) => {
            return _api_post_tasks_start_offboarding(data);
        },
        {
            onError: (error) => {
                return console.log({ error });
            },
            onSuccess: (response) => {
                if (response?.success) {
                    // supprimer aussi le contexte user offboarding
                    setUserOffboarding(null);
                    toast.setShow({
                        visible: true,
                        level: "success",
                        content:
                            "L'offboarding de ce collaborateur à bien été démarré",
                    });
                    return navigate(
                        `${ROUTES.offboarding.home}${location.search}`
                    );
                }
                return;
            },
        }
    );
    // * FUNCTIONS
    // * FUNCTIONS
    // * FUNCTIONS
    const cbOnSuccessAdd = (task) => {
        CtxSetAddTasksLocally([task]);
        methods.reset();
        onCloseModal({ setStateDialogIndividualTask: setStateDialog });
        return;
    };

    const submitTasks = () => {
        // formater les tasks avant envoi
        const format_tasks = CtxTasksLocally.map((task) => {
            return {
                name: task.name,
                description: task.description,
                due_date: task.due_date,
                assigned_to: task.assigned_to?.email,
                related_to: task.related_to?.email ?? null,
                task_to_validate: task.task_to_validate ?? false,
                validator_email: task.who_validate?.email ?? null,
                type: task.type,
                category_id: task.category,
                document_required: task.document_required,
                document_action: task.document_action,
                template_doc_ids:
                    task.documents_template?.map((file) => file.id) ?? [],
                new_doc_ids: task.saved_files?.map((file) => file.id),
            };
        });
        mutate({
            id_user: user_offboarding?.id,
            tasks: format_tasks,
        });
    };

    // * FORMATED
    const list_table = _format_tasks_definition_table(CtxTasksLocally);

    return {
        dialog: {
            open: stateDialog,
            onCloseModal: () =>
                onCloseModal({ setStateDialogIndividualTask: setStateDialog }),
            onConfirmModal: () =>
                onConfirmModal({
                    setStateDialogIndividualTask: setStateDialog,
                }),
            onOpenModal: () =>
                onOpenModal({ setStateDialogIndividualTask: setStateDialog }),
        },
        form: {
            methods: {
                ...methods,
                onSubmit: (data) =>
                    onConfirmModal({ methods, data, cbOnSuccessAdd }),
            },
        },
        footer: {
            validate_all_step: {
                data,
                isLoading: is_loading_send_tasks,
            },
        },
        list_tasks_formated: list_table,
        navigation: {
            buttonNextStep: (e) => {
                e.preventDefault();
                submitTasks();
            },
            buttonBackStep: () => {
                return navigate(
                    `${ROUTES.offboarding.prepare_offboarding}/equipments_access${location.search}`
                );
            },
        },
    };
};

export default useLogicTaskIndividual;
